import { Box, Typography } from "@mui/material";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import CheckRounded from "@mui/icons-material/CheckRounded";
import { useDayCoach } from "./DayCoachContext";
import { todayGoalCount } from "../../pages/CRM/dayPlan";
export default function DayNextButton() {
  const coach = useDayCoach();
  if (!coach?.enabled) return null;

  const queueLeft = coach.remaining.length;
  const done = !coach.loading && queueLeft === 0 && coach.doneCount > 0;
  const clear = !coach.loading && queueLeft === 0 && coach.doneCount === 0;
  const dayLeft = coach.goal ? todayGoalCount(coach.goal.done, coach.goal.target) : null;

  let title = "Cerrar el día";
  let line = dayLeft == null ? "Meta de hoy" : dayLeft === 0 ? "Meta de hoy lista" : `${dayLeft} restantes`;
  let onClick = coach.startGuide;

  if (done) {
    onClick = coach.startGuide;
  } else if (clear) {
    onClick = coach.openBrief;
  } else if (!coach.active.length && coach.skipped.length) {
    onClick = coach.resumeSkipped;
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        ml: 1,
        pl: 0.7,
        pr: 1.35,
        py: 0.55,
        border: "1px solid rgba(255,255,255,0.14)",
        borderRadius: "999px",
        cursor: "pointer",
        font: "inherit",
        textAlign: "left",
        flexShrink: 0,
        color: "#fff",
        background: done || (dayLeft === 0)
          ? "linear-gradient(180deg, #10b981 0%, #059669 100%)"
          : "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.16)",
        transition: "background .18s ease, box-shadow .18s ease",
        "&:hover": {
          boxShadow: "0 8px 18px rgba(15, 23, 42, 0.22)",
        },
      }}
    >
      <Box
        sx={{
          width: 30,
          height: 30,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          bgcolor: "rgba(255,255,255,0.14)",
          flexShrink: 0,
        }}
      >
        {done || clear || dayLeft === 0 ? <CheckRounded sx={{ fontSize: 16 }} /> : <ArrowForwardRounded sx={{ fontSize: 16 }} />}
      </Box>
      <Box sx={{ minWidth: 0, pr: 0.25 }}>
        <Typography sx={{ fontSize: "0.78rem", fontWeight: 750, letterSpacing: "-0.02em", lineHeight: 1.15, color: "#fff", whiteSpace: "nowrap" }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: "0.68rem", fontWeight: 600, color: "rgba(255,255,255,0.72)", lineHeight: 1.2, mt: 0.15, whiteSpace: "nowrap" }}>
          {line}
        </Typography>
      </Box>
    </Box>
  );
}
